/**
 * Tom da pill de situacao, sempre por token semantico. O selo tem significado —
 * verde e sucesso, ambar e atencao, vermelho e problema — nao decoracao
 * (docs/DESIGN-SYSTEM.md, secao 5, StatusBadge).
 */
export type StatusTone = 'success' | 'warning' | 'destructive' | 'info' | 'neutral';

/**
 * Classe de cada tom. Fundo solido no token da cor, texto no foreground do
 * token — o par ja passa em contraste AA nos dois temas (ver tokens.css).
 * Nenhuma cor fixa: a regra teg/cores-fixas recusaria.
 */
export const STATUS_TONE: Record<StatusTone, string> = {
  success: 'border-transparent bg-success text-success-foreground',
  warning: 'border-transparent bg-warning text-warning-foreground',
  destructive: 'border-transparent bg-destructive text-destructive-foreground',
  info: 'border-transparent bg-info text-info-foreground',
  neutral: 'border-transparent bg-muted text-muted-foreground',
};
